import React from 'react';
import { Card } from '@/components/ui/card';
import { AdComponent } from './AdComponent';

export function FeedAd() {
  return (
    <Card className="relative hover:bg-accent/50 transition-colors">
      <div className="p-4">
        <div className="text-xs text-muted-foreground mb-2">Sponsored</div>
        <AdComponent
          slot="feed-ad-slot" // Replace with your actual AdSense slot ID
          style={{
            minHeight: '250px',
            backgroundColor: 'transparent',
          }}
        />
      </div>
    </Card>
  );
}